<template>
  <div
    class="ol-progress-chips mt-2"
  >
    <template v-for="pItem in progressItems">
      <div
        :key="pItem.order"
        class="ol-progress-chip"
      >
        <v-chip
          class="text-uppercase no-hover"
          :class="{
            'previous-stage': pItem.order < progressItem.order,
            'future-stage': pItem.order > progressItem.order,
            'current-stage': pItem.currentStage
          }"
          label
          small
        >
          <span class="hidden-content-sm-and-down">{{ pItem.Name || 'Client' }}</span>
        </v-chip>
        <div
          v-show="pItem.currentStage"
          class="status-text mt-1"
        >
          {{ status }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'StagesStatusIndicator',
  props: {
    progressItems: { type: Array, default: () => [] },
    progressItem: { type: Object, default: () => ({}) },
    status: { type: String, default: '' }
  }
}
</script>

<style lang="scss">
.ol-progress-chips  {
  display: flex;
  flex-direction: row;
  line-height: .8rem;
  justify-content:flex-start;

  > * > .v-chip {
    border-radius: 6px !important;
  }

  > *:not(:first-child):not(:last-child) > .v-chip  {
    border-radius: 0 !important;
  }
  > *:first-child:not(:last-child) > .v-chip  {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  > *:last-child:not(:first-child) > .v-chip  {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .ol-progress-chip {
    position:relative;
    padding: 3px 0px;
    .v-chip {
      justify-content: center;
      display: flex;
      font-weight:  bold;
      &.previous-stage {
        background: var(--v-skyblue-base);
      }
      &.current-stage {
        background: var(--v-lightseagreen-base);
        color: white;
      }
      &.future-stage {
        background: var(--v-lavendergray-base);
      }
    }
    .status-text {
      font-size: 0.66rem;
      color: var(--v-lightseagreen-base);
    }
  }

  /* TODO add v-chip with generic no-hover */
  .ol-progress-chip .v-chip.no-hover:hover::before {
    opacity: 0;
  }
}
</style>
